/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Box, Button } from '@material-ui/core'
import Pagination from '@material-ui/lab/Pagination'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { noop } from '../../helpers/utils'

function CommonPagination({ count, onChange, page }) {
  const { t } = useTranslation()
  return (
    <>
      <Box className="pagination-style-first">
        <Button
          className="custom-info-button text-transform-none"
          disableElevation
          variant="text"
          size="small"
          fullWidth
          onClick={(e) => onChange(e, 1)}
        >
          {t('firstPage')}
        </Button>
      </Box>
      <Pagination
        color="primary"
        shape="rounded"
        variant="text"
        count={count}
        onChange={onChange}
        page={page}
      />
      <Box className="pagination-style-last">
        <Button
          className="custom-info-button text-transform-none"
          disableElevation
          variant="text"
          size="small"
          fullwidth="true"
          onClick={(e) => onChange(e, count)}
        >
          {t('lastPage')}
        </Button>
      </Box>
    </>
  )
}

CommonPagination.propTypes = {
  count: PropTypes.number,
  onChange: PropTypes.func,
  page: PropTypes.number,
}
CommonPagination.defaultProps = {
  count: 0,
  onChange: noop,
  page: 0,
}
export default CommonPagination
